<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatMoneyAmount } from '../utils/format'
import moneyIcon from '../assets/money-icon.png'

const props = defineProps({
  value: { type: [Number, String], default: 0 },
  size: {
    type: String,
    default: 'md',
    validator: (v) => ['sm', 'md', 'lg'].includes(v)
  },
  tag: { type: String, default: 'span' }
})

const { locale } = useI18n()

const formatted = computed(() => {
  const n = Number(props.value)
  return formatMoneyAmount(Number.isFinite(n) ? n : 0, locale.value)
})
</script>

<template>
  <component :is="tag" class="money-amount" :class="`money-amount--${size}`">
    <img :src="moneyIcon" alt="" class="money-amount__icon" aria-hidden="true" />
    <span class="money-amount__value">{{ formatted }}</span>
  </component>
</template>

<style scoped>
.money-amount {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  vertical-align: baseline;
  line-height: 1.2;
}

.money-amount__icon {
  width: 1.125em;
  height: 1.125em;
  object-fit: contain;
  flex-shrink: 0;
}

.money-amount--sm .money-amount__icon {
  width: 14px;
  height: 14px;
}

.money-amount--md .money-amount__icon {
  width: 18px;
  height: 18px;
}

.money-amount--lg .money-amount__icon {
  width: 22px;
  height: 22px;
}
</style>
